import { useTranslation } from "react-i18next";
import { ConfirmModal } from "./ConfirmModal";

export function OptOutModal() {
  const { t } = useTranslation();

  const contentProps = {
    title: t("searchCard.modals.deniedAccess"),
    description: t("searchCard.modals.deniedAccessQuestion"),
  };
  return <ConfirmModal {...contentProps} />;
}
